import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createNewStocktakeObject } from './StocktakeUtils';
import { stocktakeService } from '../../_services';
import useWindowSize from '../new-service/useWindowSize';
import toast from '../shared/Toast';
import NotificationBell from '../notifications/NotificationBell';
import LocationPicker from '../multiLocation/LocationPicker';
import BackButton from '../common/BackButton';
import './Stocktake.css';
import './StocktakeDetail.css';
import '../new-service/service.css';

/**
 * Component for creating a new stock take as a full page
 */
const NewStocktake = (props) => {
  const [name, setName] = useState('');
  const [notes, setNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { width } = useWindowSize();

  /**
   * Handle cancel button click
   */
  const handleCancel = () => {
    props.history.push('/stocktake');
  };

  /**
   * Handle save button click
   */
  const handleSave = () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const newStocktake = createNewStocktakeObject(name, notes);

    stocktakeService.createStocktake(newStocktake)
      .then(response => {
        console.log("Create stocktake response:", response);

        // Check for success in the response
        if (response.data &&
            ((response.data.statusCode === 1 && response.data.responseData) ||
             (response.data.status === 1))) {

          // Get the stocktake ID from the response
          const stocktakeId = response.data.responseData?.data?._id || response.data.data?._id;

          if (stocktakeId) {
            props.history.push(`/stocktake/${stocktakeId}`);
          } else {
            console.error("Error: No stocktake ID in response:", response.data);
            toast.error("Failed to create stock take: No stocktake ID in response");
            setIsSubmitting(false);
          }
        } else {
          console.error("Error creating stocktake:", response.data);
          const errorMsg = response.data?.responseData?.message ||
                          response.data?.message ||
                          response.data?.error?.message ||
                          "Unknown error";
          toast.error("Failed to create stock take: " + errorMsg);
          setIsSubmitting(false);
        }
      })
      .catch(error => {
        console.error("Error creating stocktake:", error);
        const errorMessage = error.response?.data?.message || error.message || "Unknown error";
        toast.error("Failed to create stock take: " + errorMessage);
        setIsSubmitting(false);
      });
  };

  return (
    <div className="h_n _new__stocktake catalogue-no-header">
      <div className="body_container cm_bg_white _nowhite __add_stocktake">
        {/* New-style top nav (matches StocktakeDetail) so the pinned bell sits
            cleanly to the right of the action buttons instead of overlapping. */}
        <div className="catalogue-top-nav">
          <div className="catalogue-top-nav-container">
            <div className="catalogue-top-nav-content stocktake-top-nav-content">
              {/* Mobile-only: back arrow + title */}
              <div className="stocktake-top-nav-mobile">
                <BackButton onClick={handleCancel} ariaLabel="Back" />
                <h1 className="stocktake-top-nav-title">New Stock Take</h1>
                {/* Spacer to balance the back button so the title stays centred. */}
                <span style={{ width: '36px', height: '36px' }} />
              </div>

              {/* Desktop-only: back icon + title + action buttons */}
              <div className="stocktake-top-nav-desktop">
                <BackButton
                  onClick={handleCancel}
                  disabled={isSubmitting}
                  ariaLabel="Back to stock takes"
                />
                <h1 className="stocktake-top-nav-title">New Stock Take</h1>
                <div className="stocktake-top-nav-actions">
                  <button
                    type="button"
                    className="stocktake-nav-btn stocktake-nav-btn--neutral"
                    onClick={handleCancel}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="stocktake-nav-btn stocktake-nav-btn--primary"
                    onClick={handleSave}
                    disabled={isSubmitting}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="notif-bell-pinned-wrap">
            <LocationPicker />
            <NotificationBell />
          </div>
        </div>

        <div className="new-stocktake-page">
          <div className="container">
            <div className="stocktake-form-wrapper">
              <div className="stocktake-form-container">
                <h3 className="mb-4">Stock Take</h3>

                <div className="form-group mb-4">
                  <div className="stocktake-label-container">
                    <label className="form-label stocktake-label" htmlFor="stocktake-name">
                      Stock Take Name
                    </label>
                  </div>
                  <input
                    id="stocktake-name"
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={isSubmitting}
                    placeholder="e.g. August 2025 Stock Take"
                  />
                </div>

                <div className="form-group">
                  <div className="stocktake-label-container">
                    <label className="form-label stocktake-label" htmlFor="stocktake-notes">
                      Stock Take Notes
                    </label>
                  </div>
                  <textarea
                    id="stocktake-notes"
                    className="form-control"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    disabled={isSubmitting}
                    placeholder="Add any notes or context about this stock take (e.g. end-of-month check, new product added)"
                    rows={6}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Mobile-only bottom action bar — matches StocktakeDetail. */}
          {width < 1101 && (
            <div className="stocktake-mobile-action-bar">
              <button
                type="button"
                className="stocktake-nav-btn stocktake-nav-btn--neutral stocktake-mobile-action"
                onClick={handleCancel}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="stocktake-nav-btn stocktake-nav-btn--primary stocktake-mobile-action"
                onClick={handleSave}
                disabled={isSubmitting}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(NewStocktake);
